import Class from './c-select';
import './c-select@';

export default Class;